import { render, staticRenderFns } from "./PluginEditPanel.vue?vue&type=template&id=e5a95290&scoped=true"
import script from "./PluginEditPanel.vue?vue&type=script&lang=ts"
export * from "./PluginEditPanel.vue?vue&type=script&lang=ts"
import style0 from "./PluginEditPanel.vue?vue&type=style&index=0&id=e5a95290&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a95290",
  null
  
)

export default component.exports